import type { Domain } from '@shared/types/project.type';

export const ACCOUNT_DOMAIN_STORAGE_KEY = 'accountDomain';

/** Normalize domain strings from account/sign-up (trim only; no fixed domain list). */
export function normalizeAccountDomainToProjectDomain(raw: string | null | undefined): Domain | null {
  const key = String(raw ?? '').trim();
  return key.length > 0 ? key : null;
}

export function setAccountDomain(domain: string): void {
  const key = String(domain ?? '').trim();
  if (!key) return;
  localStorage.setItem(ACCOUNT_DOMAIN_STORAGE_KEY, key);
}

/** Domain from account creation / login, used for projects and uploads when not set on the project. */
export function getAccountDomain(): Domain | null {
  return normalizeAccountDomainToProjectDomain(localStorage.getItem(ACCOUNT_DOMAIN_STORAGE_KEY));
}

export function clearAccountDomain(): void {
  localStorage.removeItem(ACCOUNT_DOMAIN_STORAGE_KEY);
}

/** Project domain if set, otherwise the signed-in account domain. */
export function resolveUploadDomain(projectDomain?: string | null): Domain | null {
  return normalizeAccountDomainToProjectDomain(projectDomain) ?? getAccountDomain();
}
